module.exports = __webpack_public_path__ + "img/KSC01742.aadbd215.jpg";